import React, { PropsWithChildren } from "react";
//#region types
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const TitledContainerBodyText: React.FC<PropsWithChildren> = (props) => {
  return (
    <Grid item container className={cssExports.bodyText}>
      {props.children}
    </Grid>
  );
};

export default TitledContainerBodyText;
